import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Layout, Row, Col } from "antd";
import { Redirect } from "react-router-dom";
import Sidebar from "./components/menu/Sidebar";
import MenuHeader from "./components/header";
import MenuFooter from "./components/footer";
import ScrollTop from "./components/scroll-to-top";

const { Content } = Layout;

export default function VerticalLayout(props) {
    const { children } = props;

    const [visible, setVisible] = useState(false);
    const [redirect, setRedirect] = useState(false);

    // Redux
    const customise = useSelector(state => state.customise)
    const auth = useSelector((state) => state.login);

    useEffect(() => {
        // Function to handle logout across all tabs
        const handleStorageChange = (event) => {
            console.log(event.key + " - " + event.newValue);
            if (event.key === 'authenticated' && event.newValue == null) {
                setRedirect(true);
            }
        };

        // Listen for changes in localStorage across all tabs
        window.addEventListener('storage', handleStorageChange);

        // Clean up event listener
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    return (
        auth.isAuthenticated && !redirect ? (
            <Layout className="hp-app-layout">
                <Sidebar visible={visible} setVisible={setVisible} />

                <Layout className="hp-bg-color-dark-90">
                    <MenuHeader setVisible={setVisible} className="vertical_header" />

                    <Content className="hp-content-main hp-mt-24">
                        <Row justify="center">
                            {
                                customise.contentWidth == "full" && (
                                    <Col span={24}>
                                        {children}
                                    </Col>
                                )
                            }

                            {
                                customise.contentWidth == "boxed" && (
                                    <Col xxl={20} xl={22} span={24}>
                                        {children}
                                    </Col>
                                )
                            }
                        </Row>
                    </Content>

                    {/* <MenuFooter /> */}
                </Layout>

                {/* <ScrollTop /> */}
            </Layout>
        ) :
            <Redirect to="/login" />

    );
};